var _rect, _rect2, _rect3, _rect4, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 43,
    viewBox: "0 0 43 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 21.2132,
    width: 8,
    height: 30,
    rx: 4,
    transform: "rotate(45 21.2132 0)",
    fill: "#44AE55"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 26.8701,
    y: 36.7695,
    width: 8,
    height: 30,
    rx: 4,
    transform: "rotate(135 26.8701 36.7695)",
    fill: "#0C78F1",
    fillOpacity: 0.9
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 15.5564,
    y: 5.65686,
    width: 8,
    height: 30,
    rx: 4,
    transform: "rotate(-45 15.5564 5.65686)",
    fill: "#F79E20",
    fillOpacity: 0.9
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 21.2132,
    y: 42.4264,
    width: 8,
    height: 30,
    rx: 4,
    transform: "rotate(-135 21.2132 42.4264)",
    fill: "#F6494D",
    fillOpacity: 0.9
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5408 25.0095C19.8752 25.4373 19 24.9595 19 24.1683V18.8317C19 18.0405 19.8752 17.5627 20.5408 17.9905L24.6915 20.6588C25.3038 21.0525 25.3038 21.9475 24.6915 22.3412L20.5408 25.0095Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.af275a614c07ba4be9e6f95a6bb48357.svg";
export { ForwardRef as ReactComponent };